import { Text, Tooltip, useToggle } from '@factorialco/deprecated-design-system'
import { ProjectionKind, useDocumentsDataTable } from 'generated/resources/datatable.graphql'
import { DocumentsDocumentItemFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

export type FolderWithRootFolder = DocumentsDocumentItemFragment['folder']

type DocumentsDataTableProjection = Parameters<typeof useDocumentsDataTable>[0][number]

const DEFAULT_NO_VALUE = '-'

type Props = {
  folder: FolderWithRootFolder
}

const FolderWithParentFolder = ({ folder }: Props) => {
  const [open, toggle] = useToggle(false)

  const folderRender = (
    <Text size="200" overflowWrap>
      {folder?.name || DEFAULT_NO_VALUE}
    </Text>
  )

  const parentFolderName = folder?.rootParentFolder?.name

  if (!parentFolderName) return folderRender

  return (
    <Tooltip.Alt
      attachment="bottom center"
      label={i18n.t('documents.employee.list.root_folder_tooltip', {
        root_folder_name: parentFolderName,
      })}
      open={open}
      toggle={toggle}
    >
      {folderRender}
    </Tooltip.Alt>
  )
}

const folderProjection: () => DocumentsDataTableProjection = () => ({
  identifier: 'folder',
  title: i18n.t('documents.employee.list.folder'),
  kind: ProjectionKind.Custom,
  template: '',
  render: ({ folder }) => <FolderWithParentFolder folder={folder} />,
  colSpan: 1,
})

export default folderProjection
